import helpCenterMd from '../../content/infoPages/help-center.md';
import careerMd from '../../content/infoPages/career.md';
import forumMd from '../../content/infoPages/forum.md';
import termsMd from '../../content/infoPages/terms.md';
import privacyMd from '../../content/infoPages/privacy.md';
import communityMd from '../../content/infoPages/community-guidelines.md';
import cookiesMd from '../../content/infoPages/cookies.md';
import copyrightMd from '../../content/infoPages/copyright.md';

export const INFO_PAGE_LINKS = [
  { slug: 'help-center', labelKey: 'help_center' },
  { slug: 'career', labelKey: 'career' },
  { slug: 'forum', labelKey: 'forum' },
  { slug: 'terms', labelKey: 'termsAndConditions' },
  { slug: 'privacy', labelKey: 'privacy_policy' },
  { slug: 'community-guidelines', labelKey: 'community_guidelines' },
  { slug: 'cookies', labelKey: 'cookies_policy' },
  { slug: 'copyright', labelKey: 'copyright_policy' },
];

export const INFO_PAGE_REGISTRY = {
  'help-center': {
    title: 'Help Center',
    summary: 'Fast support, real humans, and all the how-tos for the platform.',
    accent: '#0b7fab',
    heroImage: 'images/img2/AI_Powered_Recommendations.jpg',
    markdownUrl: helpCenterMd,
  },
  career: {
    title: 'Careers',
    summary: 'Join the builders behind the world\'s most global sports network.',
    accent: '#d46c00',
    heroImage: 'images/img2/career.png',
    markdownUrl: careerMd,
  },
  forum: {
    title: 'Forum Standards',
    summary: 'Keep discussions clean, insightful, and on-topic.',
    accent: '#7a3eb1',
    heroImage: 'images/img2/forum.png',
    markdownUrl: forumMd,
  },
  terms: {
    title: 'Terms & Conditions',
    summary: 'The rules of the platform and how we operate responsibly.',
    accent: '#195167',
    heroImage: 'images/img2/confirmation.jpg',
    markdownUrl: termsMd,
  },
  privacy: {
    title: 'Privacy Policy',
    summary: 'How we collect, safeguard, and give you control over data.',
    accent: '#008c72',
    heroImage: 'images/img2/confirmation_code_illustration.png',
    markdownUrl: privacyMd,
    apiSlug: 'privacy-policy',
  },
  'community-guidelines': {
    title: 'Community Guidelines',
    summary: 'The culture code for everyone on Meanc.',
    accent: '#c0392b',
    heroImage: 'images/img2/com.png',
    markdownUrl: communityMd,
  },
  cookies: {
    title: 'Cookies Policy',
    summary: 'Understand, manage, and fine-tune your cookie preferences.',
    accent: '#9c6b1c',
    heroImage: 'images/img2/cp.png',
    markdownUrl: cookiesMd,
  },
  copyright: {
    title: 'Copyright Policy',
    summary: 'Protection for creators, clubs, and partners across the network.',
    accent: '#2c3e50',
    heroImage: 'images/img2/cc-icon4.png',
    markdownUrl: copyrightMd,
  },
};

export const getInfoPage = (slug = '') => INFO_PAGE_REGISTRY[slug.toLowerCase()];
